import { useEffect, useRef, useState } from "react";
import {
  getCachedBrazilianCurves,
  loadBrazilianCurvesCatalog,
  retryBrazilianCurvesCatalogOnNavigation,
} from "../utilis/chartsCatalog";

const applyCatalogResult = (result, setters) => {
  setters.setBrazilianCurves(result.options);
  setters.setSource(result.source);
  setters.setError(result.error);
};

export function useBrazilianCurves(equipmentId) {
  const cached = getCachedBrazilianCurves();
  const [brazilianCurves, setBrazilianCurves] = useState(() => cached?.options ?? []);
  const [loading, setLoading] = useState(() => !cached?.options?.length);
  const [source, setSource] = useState(() => cached?.source ?? null);
  const [error, setError] = useState(() => cached?.error ?? null);
  const previousEquipmentIdRef = useRef(undefined);

  useEffect(() => {
    if (!equipmentId) {
      return undefined;
    }

    let cancelled = false;
    const setters = { setBrazilianCurves, setSource, setError };

    const load = async () => {
      const hadOptions = Boolean(getCachedBrazilianCurves()?.options?.length);
      const isEquipmentChange =
        previousEquipmentIdRef.current !== undefined &&
        previousEquipmentIdRef.current !== equipmentId;

      previousEquipmentIdRef.current = equipmentId;

      if (!hadOptions) {
        setLoading(true);
      }

      const result = isEquipmentChange
        ? await retryBrazilianCurvesCatalogOnNavigation()
        : await loadBrazilianCurvesCatalog();

      if (cancelled) return;

      applyCatalogResult(result, setters);
      setLoading(false);
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [equipmentId]);

  return { brazilianCurves, loading, source, error };
}

export default useBrazilianCurves;
